require("-!/var/www/fauna-politica-cms/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!sass-loader?sourceMap!/var/www/fauna-politica-cms/node_modules/font-awesome-sass-loader/font-awesome-sass-styles.loader.js!/var/www/fauna-politica-cms/font-awesome.config.js");


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass-loader/index.loader.js!./font-awesome.config.js
// module id = 4
// module chunks = 1